// extracted by mini-css-extract-plugin
module.exports = {"mainNav":"Footer_mainNav__3530q","mainLogo":"Footer_mainLogo__lRIFX","brandLogo":"Footer_brandLogo__1t507","logo":"Footer_logo__3ACxa"};